<template>
	<div class="remoteSensingpedia">
		<!--头部banner-->
		<!-- <div class="banner">
      <div class="bannerTitle">资源工具</div>
      <div class="bannerzn">
        RESOURCE TOOLS
      </div>
    </div> -->

		<!--主体-->
		<div class="main m-b-30">
			<div class="elbox">
				<el-row>
					<el-col :span="4">
						<div class="grid-content bg-purple">
							<div class="left">
								<div class="content">
									<div class="remoteSensingpedia">资源工具</div>
									<div class="menu">
										<el-menu :default-openeds="open_list" :default-active="activeItem" class="el-menu-vertical-demo" @select="handleSelect" @open="handleOpen" @close="handleClose">
											<div v-for="(father, i) in menu" :key="i">
												<el-submenu v-if="father.children" :index="father.id">
													<template slot="title">
														<i :class="father.icon"></i>
														<span>{{ father.name }}</span>
													</template>
													<el-menu-item v-for="(item, i) in father.children" :key="i" :index="item.id">
														<span slot="title">{{ item.name }}</span>
													</el-menu-item>
												</el-submenu>

												<el-menu-item v-else :index="father.id">
													<i :class="father.icon"></i>
													<span slot="title">{{ father.name }}</span>
												</el-menu-item>
											</div>
										</el-menu>
									</div>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="20" v-if="secdShow">
						<div class="grid-content bg-purple-light" v-if="activeItem == '-2' && menu[1].chid">
							<div class="right">
								<div class="content secd_Info">
									<div class="title">{{ secdInfo.name }}</div>
									<div class="sj">发布时间：{{ secdInfo.createTime }}</div>
									<img :src="imgServeUrl + secdInfo.image" alt="" width="500" height="580" class="bg" />
									<div class="conDesc" style="font-weight: 700; line-height: 60px">简介：</div>
									<div v-html="secdInfo.content" class="conDesc"></div>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="18" v-else>
						<div class="grid-content bg-purple-light" v-if="activeItem == '-1' && menu[0].chid">
							<div class="right">
								<div class="content">
									<div>
										<div class="conBody" v-for="(item, i) in menu[0].chid" :key="i" style="margin-bottom: 15px">
											<div class="conTitle" v-if="item.jumpAddress.indexOf('http') == '-1'">{{ item.name }}</div>
											<a class="conTitle" style="color: #00aaff" v-else :href="item.jumpAddress">{{ item.name }}</a>
											<div v-html="item.content" class="conDesc"></div>
										</div>
										<div class="foot">
											<div class="pagediv" v-if="menu[0].chid.length > 0">
												<el-pagination
													@size-change="handleSizeChange"
													@current-change="handleCurrentChange"
													:current-page="currentPage"
													:page-sizes="[10, 20, 30, 50]"
													:page-size="pageSize"
													layout="total, sizes, prev, pager, next, jumper"
													:total="listTotal"
												>
												</el-pagination>
												<!-- <el-button size="mini" @click="goPage()">Go</el-button> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="grid-content bg-purple-light" v-if="activeItem == '-2' && menu[1].chid">
							<div class="right">
								<div class="content" style="display: flex; flex-wrap: wrap; justify-content: space-between">
									<div class="kpdx" v-for="(item, i) in menu[1].chid" :key="i" style="width: 300px; margin: 8px; cursor: pointer" @click="selectIemScrd(item)">
										<img style="background: #000" :src="imgServeUrl + item.image" alt="" width="300" height="280" v-if="item.image.indexOf('.mp4') == '-1'" />
										<video style="background: #000" v-else :src="imgServeUrl + item.image" alt="" width="300" height="280"></video>
										<div style="padding: 15px">
											<div style="font-size: 18px; font-weight: 700; text-align: center" class="title">{{ item.name }}</div>
										</div>
									</div>
								</div>
								<div class="foot" style="background-color: #fff">
									<div class="pagediv" v-if="menu[1].chid.length > 0">
										<el-pagination
											@size-change="handleSizeChange"
											@current-change="handleCurrentChange"
											:current-page="currentPage"
											:page-sizes="[10, 20, 30, 50]"
											:page-size="pageSize"
											layout="total, sizes, prev, pager, next, jumper"
											:total="listTotal"
										>
										</el-pagination>
										<!-- <el-button size="mini" @click="goPage()">Go</el-button> -->
									</div>
								</div>
							</div>
						</div>
						<div class="grid-content bg-purple-light" v-if="activeItem == '-3' && menu[2].chid">
							<div class="right">
								<div class="content">
									<div style="display: flex; flex-wrap: wrap">
										<div class="conBody" v-for="(item, i) in menu[2].chid" :key="i" style="margin-bottom: 15px">
											<div class="conTitle">{{ item.name }}</div>
											<div v-html="item.content" class="conDesc"></div>
										</div>
									</div>
									<div class="foot">
										<div class="pagediv" v-if="menu[2].chid.length > 0">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="currentPage"
												:page-sizes="[10, 20, 30, 50]"
												:page-size="pageSize"
												layout="total, sizes, prev, pager, next, jumper"
												:total="listTotal"
											>
											</el-pagination>
											<!-- <el-button size="mini" @click="goPage()">Go</el-button> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'remoteSensingpedia',
	components: {},
	data() {
		return {
			currentPage: 1,
			listTotal: 0,
			pageSize: 10, //页
			pageNum: 1, //条
			imgServeUrl: window.dataManage.imgDev,
			menu: [
				{
					id: '-1',
					name: '资源工具',
					icon: 'el-icon-s-management',
					chid: []
				},
				{
					id: '-2',
					name: '科普产品',
					icon: 'el-icon-s-opportunity',
					chid: []
				},
				{
					id: '-3',
					name: '国家标准',
					icon: 'el-icon-office-building',
					chid: []
				}
			],
			secdShow: false,

			open_list: ['Satelliteintroduction'],
			secdInfo: {},
			activeItem: '-1'
		}
	},
	created() {
		this.getgrayList()
	},
	mounted() {},
	watch: {
		// activeItem(newValue) {
		//   this.getListData(newValue)
		// }
	},
	methods: {
		handleSizeChange(val) {
			this.pageSize = val
			this.getgrayList()
		},
		handleCurrentChange(val) {
			this.pageNum = val
			this.currentPage = val
			// this.pageSize = val
			this.getgrayList()
		},
		goPage() {
			this.pageNum = this.goPageNum
			this.getgrayList()
		},
		//获取遥感百科
		async getListData(type, chrdId) {
			if (type == '-1') {
				try {
					let res = await this.$http.get(this.$const.Platformconsulting.toolListURl + `?pageNum=${this.pageNum}&pageSize=${this.pageSize}`)
					if (res.code === 200) {
						this.menu[0].chid = res.rows
						this.listTotal = res.total
					}
				} catch (e) {
					console.log(e)
				}
			} else if (type == '-2') {
				var parms = {
					productTypeId: chrdId || ''
				}

				try {
					let res = await this.$http.get(this.$const.Platformconsulting.productListURl, parms)
					if (res.code === 200) {
						this.menu[1].chid = res.rows
						this.listTotal = res.total
					}
				} catch (e) {
					console.log(e)
				}
			} else if (type == '-3') {
				try {
					let res = await this.$http.get(this.$const.Platformconsulting.nationalStandardListURl)
					if (res.code === 200) {
						this.menu[2].chid = res.rows
						this.listTotal = res.total
					}
				} catch (e) {
					console.log(e)
				}
			}
		},
		async selectIemScrd(item) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.productDeseURl + item.id)
				if (res.code === 200) {
					this.secdInfo = res.data
					this.secdShow = true
				}
			} catch (e) {
				console.log(e)
			}
		},
		async getgrayList() {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.productTypeListURl)
				if (res.code === 200) {
					this.menu[1].children = res.data

					this.menu = [
						{
							id: '-1',
							name: '资源工具',
							icon: 'el-icon-s-management',
							chid: []
						},
						{
							id: '-2',
							name: '科普产品',
							icon: 'el-icon-s-opportunity',
							children: res.data,
							chid: []
						},
						{
							id: '-3',
							name: '国家标准',
							icon: 'el-icon-office-building',
							chid: []
						}
					]
					this.getListData(this.activeItem)
				}
			} catch (e) {
				console.log(e)
			}
		},

		handleOpen(key, keyPath) {
			console.log(key, keyPath)
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath)
		},
		async handleSelect(key, keyPath) {
			this.secdShow = false
			console.log(key, keyPath)
			this.activeItem = keyPath[0]
			if (keyPath.length == 1) {
				this.getListData(this.activeItem)
			} else if (keyPath.length == 2) {
				this.getListData(this.activeItem, keyPath[1])
			}
		}
	}
}
</script>

<style lang="scss" scoped>
$height: 800px;
.remoteSensingpedia {
	.banner {
		width: 100%;
		min-width: 1200px;
		height: 25vh;
		background: url('~@/assets/imgs/remoteSensingpedia/zy.png') no-repeat;
		background-size: 100% 100%;
		background-position: center;
		.bannerTitle {
			width: 80%;
			margin: 0 auto;
			padding-top: 80px;
			line-height: 60px;
			font-size: 28px;
			color: #f5f5f5;
		}
		.bannerzn {
			width: 80%;
			margin: 0 auto;
			line-height: 40px;
			font-size: 22px;
			color: #f5f5f5;
		}
	}

	.main {
		// margin-top: -50px;

		.elbox {
			margin: 0 auto;
			width: 100%;

			.left {
				width: 100%;
				padding: 0 0 0 50px;

				.content {
					width: 100%;
					height: $height;
					background: #fff;
					border: 1px solid #dde4ea;

					.menu {
						height: calc(100% - 50px);
						overflow-y: auto;
						scrollbar-width: none; /* firefox */
						-ms-overflow-style: none; /* IE 10+ */
						&::-webkit-scrollbar {
							/* Chrome Safari */
							display: none;
						}
					}

					.el-menu {
						border-right: none;

						li.el-menu-item.is-active::before {
							display: inline-block;
							content: '';
							width: 5px;
							height: 15px;
							background: #3867e9;
							position: absolute;
							top: 0;
							bottom: 0;
							margin: auto;
							left: 0;
						}
					}

					.remoteSensingpedia {
						padding-left: 40px;
						height: 50px;
						line-height: 50px;
						font-size: 20px;
						font-weight: bold;
					}

					ul.remoteSensingpedia_item {
						overflow: hidden;
					}
				}
			}

			.right {
				width: 100%;
				padding: 0 50px 0 20px;
				.content:after {
					content: ' ';
					width: 300px; //这个宽度和子元素宽度一致
					height: 0;
					display: block;
					margin: 8px;
				}
				height: $height;
				.content {
					width: 100%;

					background: #fff;
					margin: 0 auto;
					border: 1px solid #dde4ea;
					padding: 25px;
					overflow-y: auto;
					scrollbar-width: none; /* firefox */
					-ms-overflow-style: none; /* IE 10+ */

					&::-webkit-scrollbar {
						/* Chrome Safari */
						display: none;
					}
					.kpdx {
						cursor: pointer;
						position: relative;
						border: 1px solid #f1f1f1;
						.title {
							white-space: nowrap; /* 防止文本换行 */
							overflow: hidden; /* 隐藏溢出的内容 */
							text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
						}
						.pro_ducer {
							margin: 10px 0;
							width: 120px;
							height: 30px;
							line-height: 30px;
							text-align: center;
							font-family: ReeJi-BigRuixain, ReeJi-BigRuixain;
							font-weight: normal;
							font-size: 14px;
							color: #ffffff;
							background: url('~@/assets/imgs/remoteSensingpedia/jx.png') no-repeat;
							background-size: 100% 100%;
							background-position: center;
						}
						.wg {
							width: 150px;
							height: 150px;
							position: absolute;
							right: 0;
							bottom: 0;
							background: url('~@/assets/imgs/remoteSensingpedia/wg.png') no-repeat;
							background-size: 100% 100%;
							background-position: center;
						}
					}
					.kpdx:hover {
						background: rgba(21, 65, 140, 0.08);
					}

					// div:nth-child(1) {
					//   // text-align: center;
					//   font-size: 22px;
					//   font-weight: 400;
					//   margin-bottom: 30px;
					// }
				}
			}
		}
	}
}
.conBody {
	width: 100%;
	padding: 15px;
	background: rgba(21, 65, 140, 0.08);
	.conTitle {
		line-height: 50px;
		line-height: 50px;
		font-family: MicrosoftYaHeiUISemibold;
		font-size: 20px;
		// color: #000000;
	}
}
.secd_Info {
	text-align: center;
	.title {
		text-align: center;
		font-size: 20px;
		font-weight: 700;
		height: 80px;
		line-height: 80px;
	}
	.sj {
		text-align: center;
		color: #666;
	}
	.bg {
		text-align: center;
		margin: 15px auto;
		background: #ccc;
	}
	.conDesc {
		text-align: left;
		padding-left: 15%;
	}
}
</style>
